import { Product } from '../typing/enums'
import { ProductId } from '../typing/types'
import { ProductInfo } from '../typing/interfaces'

// TODO this info should be, "title" and "price",
// should just be put on the redux object?

export const getProductInfo = ({
  product,
}:{
  product: Product,
}) => {
  const products: {
    [key in Product]: ProductInfo
  } = {
    [Product.ghost]: {
      id: process.env.GHOST_PRICE as ProductId,
      title: Product.ghost,
      price: 12.99,
    },
  }

  return products[product]
}

export const getProductInfoById = ({
  productId,
}:{
  productId: ProductId,
}) => {
  const GHOST_PRICE = process.env.GHOST_PRICE as ProductId

  const ghostInfo = getProductInfo({
    product: Product.ghost,
  })

  const products: {
    [key in ProductId]: ProductInfo
  } = {
    [GHOST_PRICE]: { ...ghostInfo },
  }

  return products[productId]
}
